<template>
  <div class="research_group_container" v-if="researchGroupCharacter === 'leader' || researchGroupCharacter === 'approver'">
    <div class="hd research-background-color">
      <span class="icon icon-left navshare" @click="goBack" v-if="!isWapp"></span>
      <span class="header_title">审批订单</span>
    </div>
    <div class="box">
      <router-link :to="{name:'ApproveOrderDetail', query: {researchGroupNo: researchGroupNo, orderNo: order.orderNo}}" class="bd" v-for="(order, index) in waitApproveOrderList" :key="index">
        <div class="outer">
          <span class="info">下单成员：{{order.orderPerson}}</span>
          <div class="tagWrap"><span class="tag">未审批</span></div>
        </div>
        <div class="block">
          <span class="orderTime">下单时间：{{order.orderTime}}</span>
          <svg t="1583809028111" class="liveiconput" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="200" height="200"><path d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>
        </div>
        <span class="orderNumber">订单编号：{{order.orderNo}}</span>
        <span class="price">订单总金额：¥{{splitMoney(order.price)}}</span>
      </router-link>
      <div style="height: 7vw; visibility: hidden;">white</div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex'
import $ from 'jquery'
// import EMKT from '../../../../emkt'
export default {
  data () {
    return {
      waitApproveOrderList: [],
      researchGroupNo: this.$route.query.researchGroupNo
    }
  },
  watch: {
    'researchGroupDetailList': {
      handler: 'setResearchGroupByGroupNo',
      immediate: true
    }
  },
  computed: {
    ...mapGetters([
      'displayChosenResearchGroup', 'researchGroupCharacter', 'researchGroupDetailList', 'isWapp'
    ])
  },
  methods: {
    ...mapMutations([
      'UPDATE_CHOSEN_RESEARCH_INDEX'
    ]),
    setResearchGroupByGroupNo () {
      if (!this.researchGroupNo) return
      let researchGroupIndex = 0
      for (let i = 0; i < this.researchGroupDetailList.length; i++) {
        if (this.researchGroupDetailList[i].researchGroupNo === this.researchGroupNo) {
          researchGroupIndex = i
          continue
        }
      }
      this.UPDATE_CHOSEN_RESEARCH_INDEX(researchGroupIndex)
      if (this.researchGroupCharacter === 'leader' || this.researchGroupCharacter === 'approver') {
        this.fetchWaitApproveOrderList()
      }
    },
    goBack () {
      this.$router.push({name: 'ResearchGroupHome'})
    },
    splitMoney (moneyNumber) {
      if (moneyNumber === undefined) {
        return ''
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',')
    },
    fetchWaitApproveOrderList () {
      const researchGroup = this.displayChosenResearchGroup
      if (researchGroup && researchGroup.researchGroupNo) {
        this.$weui.loading('查询中')
        this.gcapi('loadWaitingApprovedOrderList', researchGroup.researchGroupNo).then(res => {
          this.$weui.loading().hide()
          if (res && res.body.result) {
            this.waitApproveOrderList = res.body.result
            console.log('waitApproveOrderList', this.waitApproveOrderList)
            if (this.waitApproveOrderList.length === 0) $.toast('您当前没有待审批的订单')
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.research_group_container {
  overflow-y:scroll;
  overflow-x:hidden;
  /*-webkit-overflow-scrolling:touch;*/
  height:100%;
}
.box {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  background-color: #efeef3;
  width: 100vw;
  height: 100vh;
  top: 14.93vw;
}
.hd {
  display: flex;
  position: fixed;
  top:0;
  left:0;
  align-items: center;
  flex-direction: row;
  /*background-color: #5878fa;*/
  width: 100vw;
  height: 14.93vw;
  z-index: 10;
  justify-content: center;
}


.navshare {
  position: absolute;
  left: 6.67vw;
  width: 10vw;
  height: 10vw;
  padding-top: 2vw;
  color:#ffffff;
}
.header_title {
  opacity: 1;
  /*margin-left: 29.33vw;*/
  max-width: 60.53vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 4.27vw;
  font-weight: 400;
}

.bd {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  /*margin-left: auto;*/
  /*margin-right: auto;*/
  margin-top: 6.67vw;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 86.67vw;
  /* height: 37.33vw; */
  padding: 5vw 0;
  flex-shrink: 0;
}

.outer {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* margin-top: 5.33vw; */
  padding-right: 8.8vw;
  padding-left: 6.67vw;
  width: 86.67vw;
}

.info {
  opacity: 1;
  width: 22.4vw;
  height: 4.53vw;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #929292;
  font-size: 3.2vw;
  font-weight: 400;
}

.tagWrap {
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  border-radius: 2.4vw;
  background-color: #fe654d;
  padding-right: 2.93vw;
  padding-left: 2.67vw;
  height: 4.8vw;
}

.tag {
  opacity: 1;
  text-align: center;
  line-height: 4.8vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.2vw;
  font-weight: 400;
}

.block {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 2vw;
  padding-right: 6.4vw;
  padding-left: 6.67vw;
  width: 86.67vw;
  height: 7.47vw;
}

.orderTime {
  opacity: 1;
  width: 48vw;
  height: 4.53vw;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #929292;
  font-size: 3.2vw;
  font-weight: 400;
}

.liveiconput {
  margin-top: 3.73vw;
  width: 5vw;
  height: 5vw;
}

.orderNumber {
  opacity: 1;
  margin-top: 2vw;
  margin-left: 6.67vw;
  max-width: 76.8vw;
  height: 4.53vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #929292;
  font-size: 3.2vw;
  font-weight: 400;
}

.price {
  opacity: 1;
  margin-top: 3.2vw;
  margin-right: 10vw;
  max-width: 34.93vw;
  height: 4.53vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #ff9400;
  font-size: 3.2vw;
  font-weight: 400;
  align-self: flex-end;
}
</style>



// WEBPACK FOOTER //
// ApproveOrder.vue?4063e7c0